<sm-title-bar pageTitle="Platform Services">
   
</sm-title-bar>

<div *ngIf="!loader" class="row" style="margin-top: 20px;
margin-bottom: 30px;">
  <div class="col-lg-12 col-md-12">
    
    <div class="links_container">
      <!-- <mat-card-header class="justify-content-between align-items-center mb-3" style="padding: 5px 0 5px;">
        <mat-card-title class="fs-5 mb-0"> {{ 'business_details.other_links' | translate }} </mat-card-title>
        
      </mat-card-header> -->
      <div>
        <div class="cdf_srd"  style="border-bottom: 1px solid lightgray;" (click)="openAlert()">
          <div class="book_text" >
              <div class="entry_sec">
                  <mat-icon style="color:#222">navigate_next</mat-icon>
              </div>
              <p style="color:black; font-size: 1.2rem;margin-bottom: 5px;">Cosmetics/Marketplace</p>
              <span style="color: #666666;">Get the best products in great price</span>
          </div>
      </div>
        <div class="cdf_srd"  style="border-bottom: 1px solid lightgray;" (click)="openAlert()">
          <div class="book_text" >
              <div class="entry_sec">
                  <mat-icon style="color:#222">navigate_next</mat-icon>
              </div>
              <p style="color:black;font-size: 1.2rem;margin-bottom: 5px;">Hardware & Machinery</p>
              <span style="color: #666666;">Check for furniture, tools and electronics</span>
          </div>
      </div>
        <div class="cdf_srd"  style="border-bottom: 1px solid lightgray;" (click)="openAlert()">
          <div class="book_text" >
              <div class="entry_sec">
                  <mat-icon style="color:#222">navigate_next</mat-icon>
              </div>
              <p style="color:black;font-size: 1.2rem;margin-bottom: 5px;">Interior Decorators</p>
              <span style="color: #666666;">Consult with experts, get quote</span>
          </div>
      </div>
        <div class="cdf_srd"  style="border-bottom: 1px solid lightgray;" (click)="openAlert()">
          <div class="book_text" >
              <div class="entry_sec">
                  <mat-icon style="color:#222">navigate_next</mat-icon>
              </div>
              <p style="color:black;font-size: 1.2rem;margin-bottom: 5px;">Loan & Finance</p>
              <span style="color: #666666;">Get the financial support, grow</span>
          </div>
      </div>
        <div class="cdf_srd"  (click)="openAlert()">
          <div class="book_text" >
              <div class="entry_sec">
                  <mat-icon style="color:#222">navigate_next</mat-icon>
              </div>
              <p style="color:black;font-size: 1.2rem;margin-bottom: 5px;">Waste/Hair Collectors</p>
              <span style="color: #666666;">Earn extra money from your wastage</span>
          </div>
      </div>
       
        
      </div>
     
    </div>
  </div>

</div>